module.exports = __webpack_public_path__ + "static/RTR_WP-4-Failure-Recovery-6f2c9463547b41152c5e0205d7c97b07.pdf";